import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectCatalogEdit = state => state.get('catalogEdit', initialState);

const makeSelectOfferCode = () =>
  createSelector(selectCatalogEdit, catalogEditState =>
    catalogEditState.get('code'),
  );

const makeSelectOfferId = () =>
  createSelector(selectCatalogEdit, catalogEditState =>
    catalogEditState.get('id'),
  );

const makeSelectCatalogResponse = () =>
  createSelector(selectCatalogEdit, catalogEditState =>
    catalogEditState.get('response'),
  );

const makeSelectIsLoading = () =>
  createSelector(selectCatalogEdit, catalogEditState =>
    catalogEditState.get('loading'),
  );

const makeSelectRedirect = () =>
  createSelector(selectCatalogEdit, catalogEditState =>
    catalogEditState.get('redirect'),
  );

export {
  selectCatalogEdit,
  makeSelectOfferCode,
  makeSelectOfferId,
  makeSelectIsLoading,
  makeSelectCatalogResponse,
  makeSelectRedirect,
};
